import React from "react";
import "../../Assets/Styles/pages/terms.scss";
import { Row } from "react-bootstrap";

const Privacy: React.FC = () => {
  const privacyContent = `
    <!DOCTYPE html>
    <html>
    <body>
    
    <p>Your privacy is very important to us. This Privacy Policy describes how eZy Watermark ("we", "us", or "our") collects, uses, and protects your information when you use our web application (the "Service").</p>
    
    <h2>1. Information We Collect</h2>
    <p><strong>Account Information:</strong> When you sign up for a user account through Google or Apple authentication, we collect your display name, email address, and profile photo URL. This information is used solely to manage your account and subscriptions.</p>
    <p><strong>Device and Technical Data:</strong> We may collect anonymized browser type, OS version, and page load statistics to improve the technical performance of our Service.</p>
    
    <h2>2. Image Processing Privacy</h2>
    <p><strong>Local Processing:</strong> Unlike typical cloud editors, eZy Watermark processes all of your images locally in your web browser. <strong>Your photos and videos are never uploaded, sent, or saved to our servers.</strong> Your files do not leave your device during the watermarking process.</p>
    
    <h2>3. Subscriptions & Payment Processing</h2>
    <p>We partner with secure, PCI-compliant third-party payment gateways (such as Stripe, the Apple App Store, and the Google Play Store) to handle recurring subscription payments. <strong>We do not collect, process, or store your credit card details or bank account numbers on our servers.</strong> All billing information is entered directly into our payment partner systems, which are governed by their respective privacy policies.</p>
    
    <h2>4. How We Use Your Information</h2>
    <p>We use account and subscription data to:</p>
    <ul>
      <li>Verify your premium status and allow template saving/sharing.</li>
      <li>Provide technical support and respond to customer queries.</li>
      <li>Enforce community guidelines and prevent fraudulent account activity.</li>
    </ul>
    
    <h2>5. Data Retention & Deletion</h2>
    <p>We retain your account data for as long as your account is active. You can request deletion of your account and associated profile information at any time by contacting our support team.</p>
    
    <h2>6. Contact Us</h2>
    <p>If you have any questions or concerns about this Privacy Policy or how we handle your data, please contact us at:</p>
    <p>Whizpool Support<br>
       Email: <a href="mailto:support@ezywatermark.com">support@ezywatermark.com</a>
    </p>
    
    <h6>Written/Updated: June 12, 2026</h6>
    
    </body>
    </html>`;

  return (
    <Row className="m-0 w-100 d-flex justify-content-center prouctSansLight text_16">
      <div
        className="w-75 text-start my-5  px-5"
        dangerouslySetInnerHTML={{ __html: privacyContent }}
      />
    </Row>
  );
};

export default Privacy;
